var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-window"},[_c('div',[_vm._v(_vm._s(_vm.$t("home.welcome")))]),_c('div',[_vm._v(_vm._s(_vm.$t("home.credit"))+": "+_vm._s(_vm.creditAmount)+"$")])])
}
var staticRenderFns = []

export { render, staticRenderFns }